/**
 * Floating "Add to cart" in product details drawer — proxies click to the main PDP
 * `product-form-component` submit button (same as standalone add-to-cart).
 */

function findMainAddToCartButton(productId) {
  const form = document.querySelector(
    `product-form-component[data-product-id="${String(productId)}"]`
  );
  if (!form) return null;
  return (
    form.querySelector('button[data-testid="standalone-add-to-cart"]') ||
    form.querySelector('button[ref="addToCartButton"][name="add"]')
  );
}

function syncFloatingAtcDisabled(proxy) {
  const productId = proxy?.dataset?.productId;
  if (!productId) return;
  const main = findMainAddToCartButton(productId);
  if (!main) {
    proxy.disabled = true;
    proxy.setAttribute('aria-disabled', 'true');
    return;
  }
  proxy.disabled = main.disabled;
  proxy.setAttribute('aria-disabled', main.disabled ? 'true' : 'false');
}

document.addEventListener(
  'click',
  (e) => {
    const proxy = e.target.closest('[data-details-care-drawer-atc-proxy]');
    if (!proxy) return;
    e.preventDefault();
    const productId = proxy.dataset.productId;
    if (!productId) return;
    const main = findMainAddToCartButton(productId);
    if (!main || main.disabled) return;
    main.click();
  },
  true
);

function initFloatingAtcSync() {
  document.querySelectorAll('[data-details-care-drawer-atc-proxy]').forEach((proxy) => {
    syncFloatingAtcDisabled(proxy);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFloatingAtcSync);
} else {
  initFloatingAtcSync();
}

document.addEventListener('shopify:section:load', initFloatingAtcSync);

function onVariantOrFormInputChange(e) {
  const t = e.target;
  if (!(t instanceof HTMLInputElement)) return;
  if (t.type !== 'radio' && t.name !== 'id') return;
  const inForm = t.closest('product-form-component');
  if (!inForm) return;
  const pid = inForm.dataset.productId;
  if (!pid) return;
  document.querySelectorAll(`[data-details-care-drawer-atc-proxy][data-product-id="${pid}"]`).forEach((proxy) => {
    syncFloatingAtcDisabled(proxy);
  });
}

document.addEventListener('change', onVariantOrFormInputChange, true);
